import BaseService from '../../BaseService.js'

export default class StatusService extends BaseService {

  constructor() {
    super('status')
  }

  async getFileStatus() {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/fileStatus`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }

  async getFachStatus() {
    await this.retrieveBackendUrl();
    return this.checkError(
      fetch(`${this.backendUrl}/fachStatus`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    );
  }
}
